import { all, call, put, takeLatest } from 'redux-saga/effects';

import { DAS_REMOVE_EXTRA_FROM_BASKET_FAILED } from '../../constants/errors';
import { basketTypes } from '../../store/basket';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';
import { removeExtraFromBasket } from '../../api/basket';

const { REMOVE_EXTRA } = basketTypes;
const { sendMessage } = messageOperations;

export const performRemoveExtraFromBasket = function* performRemoveExtraFromBasket({
  payload,
}) {
  try {
    const removeFromBasketResponse = yield call(
      removeExtraFromBasket,
      payload.bookingRef,
      payload.extras,
    );

    if (removeFromBasketResponse.errors) {
      // Handle web service errors.
      yield all(
        removeFromBasketResponse.errors.map(error => put(createError(error))),
      );
      return;
    }

    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      return;
    }

    const { extrasToRemove } = payload;

    const extrasRemoved = extrasToRemove.map(extra => extra.option.value);

    const unique = [...new Set(extrasRemoved)].join(', ');

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: `Extras successfully removed from your basket: ${unique}`,
      }),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_REMOVE_EXTRA_FROM_BASKET_FAILED,
      }),
    );
  }
};

export default takeLatest(REMOVE_EXTRA, performRemoveExtraFromBasket);
